import { of } from 'rxjs';

export const articleList = [
  {
    _id: '5f328a1790a4820012c96f2f',
    label: 'Henry meets Mona May',
    tracking: '/journal/henry-meets-mona-may',
    isLegacy: false,
    body: {
      title: 'Henry meets Mona May',
      excerpt:
        'We’re bringing you a podcast: ‘What Were You Thinking?’, created in partnership with British designer Henry Holland. A new episode every two weeks!',
      cta: {
        text: 'Discover More'
      },
      image: {
        imgXLocation:
          'https://assets-cms.vestiairecollective.com/cdn-cgi/image/f=auto,w=250,h=250,fit=crop,dpr=2/200717-moona-may-600x420px-a.jpg',
        imgXName: '200717-moona-may-600x420px-a.jpg',
        body: {
          alt: '200717-moona-may-600x420px-a'
        }
      },
      uri: 'henry-meets-mona-may'
    }
  },
  {
    _id: '5f2a936b7debae0012bbc263',
    label: 'Like 5 items challenge August',
    tracking: '/journal/like-5-items-challenge-august',
    isLegacy: false,
    additionalTracking: 'shopping-contest',
    body: {
      title: 'All You Need Is Likes (To Win €500)',
      excerpt:
        'Likes are what we’re all about at Vestiaire Collective. When you find an item you’re into and like it, you’ll receive price drop notifications, and as you build up a list of your Favourites, you’ll tailor your feed to more items you might also be interested in.',
      cta: {
        text: 'I want to win'
      },
      image: {
        imgXLocation:
          'https://assets-cms.vestiairecollective.com/cdn-cgi/image/f=auto,w=250,h=250,fit=crop,dpr=2/follow-edito.gif',
        imgXName: 'follow-edito.gif',
        body: {
          alt: 'follow-edito'
        }
      },
      uri: 'shopping-contest-august-uk'
    }
  },
  {
    _id: '5f27cfa66ab7680012be2368',
    label: 'Meet the Sellers: Henry Holland',
    tracking: '/journal/meet-the-sellers-henry-holland',
    isLegacy: false,
    body: {
      title: 'Meet the Sellers: Henry Holland',
      excerpt:
        'Designer, consultant, broadcaster, style icon and now podcast host (in association with Vestiaire Collective, of course), Henry Holland is the playful face of British fashion. We sat down with him to discuss his favourite fashion era, his dream fashion dinner and a little more about why he’s working with the Albert Kennedy Trust.',
      cta: {
        text: 'Say Hello'
      },
      image: {
        imgXLocation:
          'https://assets-cms.vestiairecollective.com/cdn-cgi/image/f=auto,w=640,h=420,fit=crop,dpr=2/200810-henry-holland-600x420px.jpg',
        imgXName: '200810-henry-holland-600x420px.jpg',
        body: {
          alt: '200810-henry-holland-600x420px'
        }
      },
      uri: 'meet-the-sellers-henry-holland'
    }
  },
  {
    _id: '5f17e6bf7989c50012996243',
    label: 'Les conseils de nos Meilleurs Vendeurs',
    tracking: '/journal/lesconseilsdenosmeilleursvendeurs',
    isLegacy: false,
    body: {
      title: 'Our Top Seller Tips',
      excerpt:
        'Follow these top tips for a chance to be featured on our Community channel, which might increase your chances of selling by up to 3 times…',
      cta: {
        text: 'Read Their Tips'
      },
      image: {
        imgXLocation:
          'https://assets-cms.vestiairecollective.com/cdn-cgi/image/f=auto,w=250,h=250,fit=crop,dpr=2/mts-bloc1.jpg',
        imgXName: 'mts-bloc1.jpg',
        body: {
          alt: 'MTS_bloc1'
        }
      },
      uri: 'our-top-seller-tips'
    }
  }
];

export const CATEGORIES = [
  {
    title: 'Inside Vestiaire',
    uri: 'inside-vestiaire',
    id: 'inside-vestiaire'
  },
  {
    title: 'How to style it',
    uri: 'how-to-style-it',
    id: 'how-to-style-it'
  },
  {
    title: 'Labels we love',
    uri: 'labbels-we-love',
    id: 'labbels-we-love'
  },
  {
    title: 'Sustainability',
    uri: 'sustainability',
    id: 'sustainability'
  },
  {
    title: 'Fashion stories',
    uri: 'fashion-stories',
    id: 'fashion-stories'
  },
  {
    title: 'My community',
    uri: 'my-community',
    id: 'my-community'
  },
  {
    title: 'Promotions',
    uri: 'promotions',
    id: 'promotions'
  },
  {
    title: 'Fashion report',
    uri: 'fashion-report',
    id: 'fashion-report'
  }
];

export class JournalMainMock {
  getEditos() {
    return of({ data: { editoList: articleList }, meta: { count: 110 } });
  }
  getCategories() {
    return of(CATEGORIES);
  }
}

export const resolverMock = {
  pageData: [{ editoList: articleList, count: 110 }, CATEGORIES]
};

export const HEADERS = {
  'x-country': 'US',
  'x-device-brand': 'other',
  'x-device-type': 'desktop',
  'x-lang-code': 'en_us',
  'x-vc-timezone': '',
  'x-support-type': 'web',
  'x-vc-currency': 'USD',
  'x-vc-language': 'en',
  'x-vc-siteid': '6'
};
